import React from 'react'
import { SolidButton } from '../../../../library/button'
import './style.scss'

const Index = ({ clickNewConfiguration }) => {
    return(
        <div className="no-channels-overlay">
            <div className="inner-no-channels-overlay">
                <div className="add-new-container">
                    <h3 className="add-title">Du har ikke konfigurert noen kanal enda.</h3>
                    <p className="add-description">For å kunne sende ut e-post og SMS må du opprette en ny kanal gjennom vår tredjepart, som kan gjøres på bare noen sekunder.</p>
                    <SolidButton onClick={() => clickNewConfiguration()} icon={<i class="fad fa-plus"></i>} color="blue" title="Sett opp en ny kanal"/>
                </div>
            </div>
        </div>
    )
}

export default Index